module.exports = __webpack_public_path__ + "img/magnifier.d633dc3a.svg";